import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getCompanies, deleteCompany } from "../actions/companyActions";

import { Button } from "@material-ui/core";

import DataListWithSearchFilter from "./DataListWithSearchFilter";

class CompanyList extends Component {
  state = {
    companies: [],
  };

  componentDidMount() {
    this.refreshData();
  }

  deleteCompany(email) {
    this.props.deleteCompany(email).then(() => {
      this.setState({
        companies: this.state.companies.filter((c) => c.email != email),
      });
    });
  }

  refreshData = () => {
    this.setState({ companies: [] });

    this.props.getCompanies().then((companies) => this.setState({ companies }));
  };

  render() {
    return (
      <Fragment>
        <Button variant="contained" color="primary" onClick={this.refreshData}>
          Zoek
        </Button>

        <DataListWithSearchFilter
          data={this.state.companies.map((company) => {
            return {
              id: company.email,
              title: company.name,
              subtitle: `${company.street} ${company.streetNumber}, ${company.city}`,
              onClick: () =>
                (window.location.href = `/company/${company.email}`),
              ctxMenu: [
                {
                  label: "Wijzigen",
                  action: () =>
                    (window.location.href = `/company/${company.email}/update`),
                },
                {
                  label: "Verwijderen",
                  action: () => this.deleteCompany(company.email),
                  confirm: true,
                },
              ],
            };
          })}
          isFetching={this.props.isFetching}
          successMessage={this.props.successMessage}
          errorMessage={this.props.errorMessage}
        />
      </Fragment>
    );
  }
}

CompanyList.propTypes = {
  getCompanies: PropTypes.func.isRequired,
  deleteCompany: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.company.deleteCompany.successMessage,
  errorMessage: state.company.deleteCompany.errorMessage,
  isFetching:
    state.company.deleteCompany.isFetching ||
    state.company.getCompanies.isFetching,
});

export default connect(mapStateToProps, { getCompanies, deleteCompany })(
  CompanyList,
);



// WEBPACK FOOTER //
// ./src/components/CompanyList.js